module.exports = __webpack_public_path__ + "static/media/getstarted.c70ede63.svg";